(function () {
  function initSizeChartToggles() {
    const toggleContainers = document.querySelectorAll('[data-size-chart-toggle]');

    toggleContainers.forEach(container => {
      // Skip if already initialized
      if (container.hasAttribute('data-initialized')) return;
      container.setAttribute('data-initialized', 'true');

      const buttons = container.querySelectorAll('.size-chart-toggle__button');
      const parentContent = container.closest('.drawer__content, .popover__content');

      if (!parentContent) return;

      const contentDivs = parentContent.querySelectorAll('[data-chart-content]');

      buttons.forEach(button => {
        button.addEventListener('click', function () {
          const chartNumber = this.getAttribute('data-chart');

          // Update button states
          buttons.forEach(btn => btn.classList.remove('active'));
          this.classList.add('active');

          // Show/hide content
          contentDivs.forEach(content => {
            const contentChart = content.getAttribute('data-chart-content');
            if (contentChart === chartNumber) {
              content.style.display = 'block';
            } else {
              content.style.display = 'none';
            }
          });
        });
      });
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChartToggles);
  } else {
    initSizeChartToggles();
  }

  // Re-initialize when drawers/popovers are opened (for dynamic content)
  document.addEventListener('click', function (e) {
    if (e.target.matches('[aria-controls*="size-chart"]')) {
      // Small delay to ensure content is rendered
      setTimeout(initSizeChartToggles, 100);

      // Position drawer below the product title
      const button = e.target;
      const drawerControl = button.getAttribute('aria-controls');

      if (drawerControl && drawerControl.includes('drawer')) {
        setTimeout(() => {
          const drawer = document.getElementById(drawerControl);
          if (drawer && drawer.classList.contains('size-chart-drawer-custom')) {
            // Find the product title element
            const productTitle = document.querySelector('.product-meta__title');
            if (productTitle) {
              const titleRect = productTitle.getBoundingClientRect();
              const calculatedTop = titleRect.bottom + 20; // 20px gap below title
              const topPosition = Math.max(calculatedTop, 162); // Never go below 162px
              drawer.style.top = topPosition + 'px';
            }
          }
        }, 50);
      }
    }
  });

  // Support Shopify section reloads
  document.addEventListener('shopify:section:load', initSizeChartToggles);
})();
